export const typeSimFilterItems =
    [
        {text: "SIM Dati", value: "SIM Dati"},
        {text: "SIM Dati e Voce", value: "SIM Dati e Voce"}
    ]
